const result = [];
const req = require.context('./', true, /\.js$/);

req.keys().forEach(key => {
  if (['./models.js', './all-models.js', './index.js'].includes(key)) return;
  const model = req(key);
  result.push(model.default);
});

export default result;
